import { render } from "./ShowBhavaTable.vue?vue&type=template&id=5223206e&scoped=true"
import script from "./ShowBhavaTable.vue?vue&type=script&lang=js"
export * from "./ShowBhavaTable.vue?vue&type=script&lang=js"

import "./ShowBhavaTable.vue?vue&type=style&index=0&id=5223206e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5223206e"]])

export default __exports__